import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    cursor_pointer: {
        cursor: "pointer"
    }
}));

export {useStyles}